






























helpers = require('../../helpers.coffee')

view_model =
  components:
    contactList: require('../contacts/list')
    reactivateRecipientModal: require('../automatic_tasks/reactivate_recipient_modal.vue')
    dashboardPanel: require('./panel')

  props: ['users_options', 'header']

  data: ->
    contacts: []
    schedule_reactivation_contact: null
    user_filter: null
    next_page: 1
    loading: false

  computed:
    filters: ->
      filters = @user_filter || {}
      filters.current_recipient_status_eq = 'converting'
      filters.s = 'last_recipient_status_updated_at DESC'
      filters

  methods:
    getClass: ->
      return 'dashboard-body' if @header
    loadContacts: ->
      return if @loading || !@next_page
      @loading = true
      params = { page: @next_page }
      params.q = @filters
      @contact_resource.index(@loadContactsSuccess, @unknownError, {params})

    loadContactsSuccess: (data) ->
      @next_page = data.meta.next_page
      @contacts = @contacts.concat(data.contacts)
      @loading = false

    reloadContacts: ->
      @next_page = 1
      @loading = false
      @contacts = []
      @loadContacts()

  watch:
    user_filter: ->
      IntercomCtrl.trackEvent('Uso do filtro de usuários para os contatos pausados')

  created: ->
    @contact_resource = new ContactsResource(Session.current_company.id)
    EventsBus.$on 'Contact::ScheduleRecipientReactivation', @openRecipientScheduleReactivationModal
    EventsBus.$on 'Contact::Refresh', @refreshContact

  beforeDestroy: ->
    EventsBus.$off 'Contact::ScheduleRecipientReactivation', @openRecipientScheduleReactivationModal
    EventsBus.$off 'Contact::Refresh', @refreshContact

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters, helpers.contacts.list_view_modes, helpers.contacts.list_wrapper)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/paused_contacts.vue